import { createNoLoadActionTypes } from './utils';
export const HANDLE_SAGA_EXCEPTION = createNoLoadActionTypes('HANDLE_SAGA_EXCEPTION');
export const SET_SAGAEXCEPTION_DATA = createNoLoadActionTypes('SET_SAGAEXCEPTION_DATA');
